import { useMutation, UseMutationResult } from 'react-query'

import { Submit, SubmitSuccess } from 'common/interfaces'
import api from 'utils/api'
import { useIsOnline } from 'utils/hook'
import { useCurrentClaimId } from 'views/AdjustersHub/utils/hooks'
import { OfflineRequestsService } from 'views/AdjustersHub/utils/offlineRequestsService'

async function sendData(data: Submit): Promise<SubmitSuccess> {
  const response = await api.post<SubmitSuccess>('documents/', data)
  return response.data
}

export default function useSubmit(): UseMutationResult<SubmitSuccess, unknown, Submit> {
  const claimID = useCurrentClaimId()
  const isOnline = useIsOnline()

  return useMutation<SubmitSuccess, unknown, Submit>(sendData, {
    mutationKey: 'submitDoc',
    onError: async (error, params) => {
      if (!isOnline) {
        await OfflineRequestsService.saveRequest({
          method: 'useSubmit',
          payload: params,
          claimID,
        })

        return
      }

      console.log('error useSubmit', error)
    },
  })
}
